import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { DropdownService } from 'src/app/services/dropdown.service';

@Component({
  selector: 'app-dropdown-list',
  templateUrl: './dropdown-list.component.html',
  styleUrls: ['./dropdown-list.component.scss'],
})
export class DropdownListComponent implements OnInit {
  @Input() opts: any = undefined;
  @Input() ownEl: HTMLEmbedElement = undefined;
  @Input() parentId: number = 0;
  @Output() emitNotClose = new EventEmitter();

  private _enteredMouse = false;
  private _selectedId = undefined;
  private _domParent = document.getElementsByTagName('ION-APP')[0];

  get selectedId() {
    return this._selectedId;
  }

  @HostListener('mouseenter') onMouseEnter() {
    this.emitNotClose.emit(true);
    this._enteredMouse = true;
  }

  @HostListener('mouseleave', ['$event']) onMouseLeave(ev) {
    this.dropdownSv.removeAllDropdowns(this._enteredMouse, ev, this.parentId);
  }

  constructor(
    private popoverController: PopoverController,
    public dropdownSv: DropdownService
  ) {}

  ngOnInit() {}

  async closePopover() {
    await this.popoverController.dismiss();
  }

  getIdEl(id) {
    const elm = document.querySelector(
      `[data-parentnodeid='${this._selectedId}']`
    );
    if (this._selectedId && elm && this._selectedId !== id) {
      this._domParent.removeChild(elm);
    }
    this._selectedId = id;
  }
}
